// utils/tokenUtils.ts
export const getTokenInfoBySymbol = (
  symbol: string
): {
  address: string;
  image: string;
} => {
  const map: Record<string, { address: string; image: string }> = {
    AVAX: {
      address: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
      image:
        "https://static.cx.metamask.io/api/v1/tokenIcons/43114/0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7.png",
    },
    SOL: {
      address: "--",
      image:
        "https://api.phantom.app/image-proxy/?image=https%3A%2F%2Fcdn.jsdelivr.net%2Fgh%2Fsolana-labs%2Ftoken-list%40main%2Fassets%2Fmainnet%2FSo11111111111111111111111111111111111111112%2Flogo.png&anim=false&fit=cover&width=256&height=256",
    },
  };

  return (
    map[symbol.toUpperCase()] || {
      address: "--",
      image: "/assets/images/profile/icn_token.svg",
    }
  );
};
